import { Box, Button, Flex, Stack, useClipboard } from '@chakra-ui/react'

import { trackEvent } from '@/client/services/analytics'

import { useToaster } from '@/components/Toast/useToaster'
import Card from '@/components/Worlds/UI/Card'

export default function SeriesReservationLinkCard({
  referralLink,
  header,
}: {
  referralLink: string
  header: () => JSX.Element
}): JSX.Element {
  const toast = useToaster()
  const { onCopy, hasCopied } = useClipboard(referralLink)

  return (
    <Card bg="info.subtle">
      <Box mb="24px">{header()}</Box>
      <Stack direction="row" align="center">
        <Flex
          textOverflow="clip"
          overflow="hidden"
          whiteSpace="nowrap"
          borderRadius="8px"
          color="fg.muted"
          border="2px solid"
          bg="bg"
          borderColor="border"
          flex={1}
          px="8px"
          height="40px"
          align="center"
        >
          {referralLink}
        </Flex>
        <Button
          variant="outline"
          onClick={() => {
            onCopy()
            trackEvent({
              category: 'SAT Bootcamp - Registration',
              action: 'copy referral link',
            })
            toast({
              title: 'Copied to clipboard!',
              status: 'success',
            })
          }}
          width="160px"
        >
          {hasCopied ? 'Copied!' : 'Copy Link'}
        </Button>
      </Stack>
    </Card>
  )
}
